import { Stack } from "@mui/material";
import { cloneElement } from "react";
import { SOCIAL_LINKS } from "../constants";

export const SocialLinks = () => {
  return (
    <Stack direction="row" spacing={2} flex={1}>
      {SOCIAL_LINKS.map(({ platform, icon, url }, idx) => {
        icon = cloneElement(icon, { color: "white", size: "28px" });
        return (
          <a key={idx} href={url} target="_blank" rel="noreferrer">
            <Stack
              data-aos="zoom-in"
              data-aos-delay={idx * 100}
              alignItems="center"
              justifyContent="center"
              height={48}
              width={48}
              bgcolor="#ffffff20"
              borderRadius={100}
            >
              {icon}
            </Stack>
          </a>
        );
      })}
    </Stack>
  );
};
